export default __webpack_public_path__ + "static/home-background-xl-b8e1976ebe4dd2b3df552a5449a742e0.jpg";